import { formatAmount } from "../../../../../utils";
import { renderFunctions } from "./services";

export const DOCUMENT_STATUS_OPTIONS = [
  { value: 'PROCESSED_IN_TIME', label: 'Traitement dans les délais' },
  { value: 'PROCESSED_APPROACHING_DEADLINE', label: 'Traitement proche de l’échéance' },
  { value: 'PROCESSED_IN_DEADLINE_EXCEEDED', label: 'Traitement après l’échéance' },
  { value: 'NOT_PROCESSED_YET', label: 'Non traité' },
  { value: 'NOT_PROCESSED_APPROACHING_DEADLINE', label: 'Non traité, échéance proche' },
  { value: 'NOT_PROCESSED_DEADLINE_EXCEEDED', label: 'Non traité, échéance dépassée' },
];

export const DEPOSIT_TABLE_VIEW_OPTIONS = [
  {
    value: 'BY_DOCUMENT',
    label: 'Par Dépôt'
  },
  {
    value: 'BY_CLIENT',
    label: 'Par Client'
  }
];

export const DEPOT_TABLE_BY_DOC_COLUMNS =  [
  {
    title: 'ID',
    dataIndex: 'depositId',
    key: 'depositId',
    align: 'left',
  },
  {
    title: 'Client',
    dataIndex: 'clientName',
    key: 'clientName',
    align: 'left',
    width: '100px',
    className: 'table-cell-bold'
  },
  {
    title: 'Dépôt',
    dataIndex: 'docCreationDate',
    key: 'docCreationDate',
    align: 'center',
    render: renderFunctions.dateColumn
  },
  {
    title: 'Date limite',
    dataIndex: 'docDueDate',
    key: 'docDueDate',
    align: 'center',
    render: renderFunctions.dateColumn
  },
  {
    title: 'Traitement',
    dataIndex: 'docLastModifiedDate',
    key: 'docLastModifiedDate',
    align: 'center',
    render: renderFunctions.dateColumn
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    render: renderFunctions.depositDocsTableRenderStatusColumn
  },
  {
    title: 'Actions',
    dataIndex: 'nextActions',
    key: 'nextActions',
    align: 'center',
    render: renderFunctions.depositDocsTableRenderActionColumn
  },
];

export const DEPOT_TABLE_BY_DEPOSIT_COLUMNS =  [
  {
    title: 'ID dépôt',
    dataIndex: 'depositId',
    key: 'depositId',
    align: 'left',
  },
  {
    title: 'Client',
    dataIndex: 'clientName',
    key: 'clientName',
    align: 'left',
    width: '100px',
    className: 'table-cell-bold'
  },
  {
    title: 'Date dépôt',
    dataIndex: 'docCreationDate',
    key: 'docCreationDate',
    align: 'center',
    render: renderFunctions.dateColumn
  },
  {
    title: 'Date limite',
    dataIndex: 'docDueDate',
    key: 'docDueDate',
    align: 'center',
    render: renderFunctions.dateColumn
  },
  {
    title: 'Nbr de docs',
    dataIndex: 'nbrOfDocs',
    key: 'nbrOfDocs',
    align: 'center',
    render: renderFunctions.docsCountColumn
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    render: renderFunctions.depositDocsTableRenderStatusColumn
  },
  // {
  //   title: 'Actions',
  //   dataIndex: 'nextActions',
  //   key: 'nextActions',
  //   align: 'center',
  //   render: renderFunctions.depositDocsTableRenderActionColumn
  // },
];

export const DEPOT_TABLE_BY_CLIENT_COLUMNS =  [
  {
    title: 'Client',
    dataIndex: 'clientName',
    key: 'clientName',
    align: 'left',
    className: 'table-cell-bold',
  },
  // {
  //   title: 'Status',
  //   dataIndex: 'status',
  //   key: 'status',
  //   render: (_, record) => {
  //     console.log({ record });
  //     return (
  //       <p>
  //         <span>Invite {record.name}</span>
  //         <span>Delete</span>
  //       </p>
  //     )
  //   },
  // },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    render: renderFunctions.depositDocsTableRenderPerClientStatusColumn
  },
  {
    title: 'Total dépôts',
    dataIndex: 'totalDeposits',
    key: 'totalDeposits',
  },
  {
    title: 'Total dépôts respectés',
    dataIndex: 'respectedDeposits',
    key: 'respectedDeposits',
    align: 'center',
  },
  {
    title: 'Total dépôts non respectés',
    dataIndex: 'nonRespectedDeposits',
    key: 'nonRespectedDeposits',
  },
  {
    title: '% Dépôts respectés',
    dataIndex: 'percentageRespectedDeposits',
    key: 'percentageRespectedDeposits',
    render: (_, rowData) => {
      const val = rowData.respectedDeposits * 100 / rowData.totalDeposits;
      return (<span>{val === 0 || val === 100 ? val :formatAmount(val, false)}%</span>);
    },
  },
  {
    title: '% Dépôts non respectés',
    dataIndex: 'percentageNonRespectedDeposits',
    key: 'percentageNonRespectedDeposits',
    render: (_, rowData) => {
      const val = rowData.nonRespectedDeposits * 100 / rowData.totalDeposits;
      return (<span>{val === 0 || val === 100 ? val : formatAmount(val, false)}%</span>);
    },
  },
];
